export const CONTACT = {
  name: "MECA AUTO CLEAN 01",
  address: "53 rue du Premier Septembre 1944, 01160 Pont-d'Ain",
  phoneDisplay: "07 56 95 10 07",
  phoneHref: "tel:+33756951007",
  whatsappNumber: "33756951007",
  whatsappLink: "https://wa.me/33756951007",
  email: "mecaautoclean01@gmail.com",
  siret: "919 451 369 00020",
  hours: [
    "Lundi – Vendredi : 8h30 – 12h00 et 13h30 – 18h00",
    "Samedi : sur rendez-vous",
    "Dimanche : fermé",
  ],
  googleReviewLink:
    "https://www.google.com/search?q=MECA+AUTO+CLEAN+01+Pont-d%27Ain+avis",
  centralepneusLink: "https://montage.centralepneus.fr/ain/pont-d-ain/42603",
  brbImportLink: "https://brbimports.com",
};
